import axios from 'axios';
// import * as qs from 'qs';
import { API_URL, PYTHON_API_URL } from '../constants';

export const getMapKey = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/map-key`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAiKey = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/ai-key`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getWeatherKey = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/weather-key`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// get list of place names and photos at city
export const getThingsToDo = async (city) => {
  const maxPlaceOptions = 20;
  try {
    // get place IDs
    const placeIDsResponse = await axios.get(`${PYTHON_API_URL}/v2/things-to-do/${city}`);
    const placeIDs = placeIDsResponse.data.slice(0, maxPlaceOptions);

    // get place names
    const placeDetailsResponse = await Promise.all(
      placeIDs.map((placeID) => axios.get(`${PYTHON_API_URL}/v2/place-details/${placeID}/displayName`)),
    );
    const placeNames = placeDetailsResponse.map((response) => response.data.displayName.text);

    // get place photos
    const photoUrls = await Promise.all(
      placeIDs.map(async (placeID) => {
        const response = await fetch(`${PYTHON_API_URL}/v2/place-photo/${placeID}`);
        if (response.ok) {
          const blob = await response.blob();
          const imageUrl = URL.createObjectURL(blob); // Create a URL for the image
          return imageUrl;
        } else {
          console.error(`Error fetching photo for place ID ${placeID}:`, response.status);
          return null;
        }
      }),
    );
    return { placeNames, photoUrls };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getPlaceDetails = async (placeId) => {
  try {
    const placeDetailsResponse = await axios.get(`${PYTHON_API_URL}/v2/place-details/${placeId}/displayName,location,formattedAddress`);
    // const placeDetailsResponse = await axios.get(`${PYTHON_API_URL}/v2/place-details/${placeId}/displayName,location,formattedAddress,currentOpeningHours,nationalPhoneNumber,priceLevel,Rating`);
    return placeDetailsResponse.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getPlacePhoto = async (placeId) => {
  try {
    const placePhotoResponse = await fetch(`${PYTHON_API_URL}/v2/place-photo/${placeId}/`);
    if (placePhotoResponse.ok) {
      const blob = await placePhotoResponse.blob();
      const imageUrl = URL.createObjectURL(blob); // Create a URL for the image
      return imageUrl;
    } else {
      console.error(`Error fetching photo for place ID ${placeId}:`, placePhotoResponse.status);
      return null;
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getLodging = async (city, budget, type) => {
  const maxPlaceOptions = 20;
  try {
    // get place IDs
    const placeIDsResponse = await axios.get(`${PYTHON_API_URL}/v2/lodging/?location=${city}&budget=${budget}&lodging=${type}`);
    const placeIDs = placeIDsResponse.data.slice(0, maxPlaceOptions);

    // get place names
    const placeDetailsResponse = await Promise.all(
      placeIDs.map((placeID) => axios.get(`${PYTHON_API_URL}/v2/place-details/${placeID}/displayName`)),
    );
    const placeNames = placeDetailsResponse.map((response) => response.data.displayName.text);

    // get place photos
    const photoUrls = await Promise.all(
      placeIDs.map(async (placeID) => {
        const response = await fetch(`${PYTHON_API_URL}/v2/place-photo/${placeID}`);
        if (response.ok) {
          const blob = await response.blob();
          const imageUrl = URL.createObjectURL(blob); // Create a URL for the image
          return imageUrl;
        } else {
          console.error(`Error fetching photo for place ID ${placeID}:`, response.status);
          return null;
        }
      }),
    );
    return { placeNames, photoUrls };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// uncomment to test in console as getThingsToDo("New York").then((data) => console.log(data));
// getPlaceDetails(["ChIJRcbZaklZwokR5bXv3FZ2qjM"]).then((data) => console.log(data));

// window.getThingsToDo = getThingsToDo;
